import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
export function FlashBanner() {
  const {
    minutes,
    seconds,
    formatted
  } = useCountdown();
  const dayName = days[new Date().getDay()];
  return <section className="fixed top-0 left-0 w-full z-50 px-4 py-3 text-center" style={{
    backgroundColor: '#0B0F19',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
  }} role="banner" aria-label="Oferta por tiempo limitado" data-id="element-73">
      <p className="text-sm font-semibold text-white" data-id="element-74">
        🔥 Oferta Flash Hoy{' '}
        <span style={{
        color: '#00E676',
        fontWeight: 700
      }} data-id="element-75">
          {dayName}
        </span>{' '}
        por Tiempo Limitado
      </p>

      <p className="mt-1.5 text-base font-bold" style={{
      color: '#22c55e',
      background: 'rgba(255,255,255,0.08)',
      padding: '4px 10px',
      borderRadius: '40px',
      boxShadow: '0 0 10px rgba(0,230,118,0.25)',
      display: 'inline-block'
    }} aria-live="polite" aria-label={`Tiempo restante: ${minutes} minutos y ${seconds} segundos`} data-id="element-76">
        {formatted}
      </p>

      <a href="https://infoliar.com/cart/56736084721996:1" className="mt-2.5 max-w-xs bg-white text-black font-bold text-base rounded-lg py-3.5 cursor-pointer transition-transform duration-150 hover:scale-[1.03] active:scale-[0.98] block text-center no-underline" style={{
      textDecoration: 'none',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '100%'
    }} aria-label="Comprar ahora" data-id="element-77">
        COMPRAR AHORA
      </a>
    </section>;
}